import { render } from "./CertificateImageManagement.vue?vue&type=template&id=04459672&scoped=true"
import script from "./CertificateImageManagement.vue?vue&type=script&lang=js"
export * from "./CertificateImageManagement.vue?vue&type=script&lang=js"

import "./CertificateImageManagement.vue?vue&type=style&index=0&id=04459672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04459672"]])

export default __exports__